(function ($) {
    'use strict';

    $.truncate = new Object({
        init: function () {
            var opts = {
                tag: 'p',
                length: 200,
                suffix: '…',
                more: 'mehr',
                less: 'weniger',
            };

            $('[data-truncate]').each(function () {
                var _options = $(this).data('truncate'),
                    options = $.extend(opts, _options);

                var _elem = $(this).find(options.tag),
                    _orig = _elem.text();

                _elem
                    .text('')
                    .append($('<span />').text(_orig.substr(0, options.length) + ' ' + options.suffix))
                    .append($('<span />').addClass('d-none').text(_orig))
                    .append(' ')
                    .append(
                        $('<a />')
                            .text(options.more)
                            .attr('href', '#')
                            .attr('data-less', options.less)
                            .attr('data-more', options.more)
                            .addClass('toggle'),
                    );
            });

            $(document).on('click', '[data-truncate] a.toggle', function (e) {
                e.preventDefault();

                if (!$(this).hasClass('show')) {
                    $(this).parent().find('span:first-child').addClass('d-none');
                    $(this).parent().find('span + span').removeClass('d-none');

                    $(this).addClass('show');
                    $(this).text($(this).attr('data-less'));
                } else {
                    $(this).parent().find('span:first-child').removeClass('d-none');
                    $(this).parent().find('span + span').addClass('d-none');

                    $(this).removeClass('show');
                    $(this).text($(this).attr('data-more'));
                }
            });
        },
    });
})(jQuery);
